import { FAQDTO } from '@/types/models';
import { client } from '@/api/client';
const FAQS_PER_PAGE = 100;
export const getFaqs = async (realm: 'fundraiser_request' | 'site'): Promise<FAQDTO[]> => {
  try {
    const result = await client.get(`/faqs?realm=${realm}&per_page=${FAQS_PER_PAGE}`);
    const firstBatch: FAQDTO[] = result.data.data ?? [];
    const lastPage: number = result.data.meta?.last_page ?? 1;
    if (lastPage <= 1) {
      return firstBatch;
    }
    const otherPages = await Promise.all(Array.from({
      length: lastPage - 1
    }, (_, index) => client.get(`/faqs?realm=${realm}&per_page=${FAQS_PER_PAGE}&page=${index + 2}`)));
    return [...firstBatch, ...otherPages.flatMap(page => page.data.data ?? [])];
  } catch (error) {
    return [];
  }
};
export const faqsOptions = (realm: 'fundraiser_request' | 'site') => {
  return {
    queryKey: ['faqs', realm],
    queryFn: () => getFaqs(realm)
  };
};